/*
| Developed by Dirupt
| Filename : index.ts
| Author : Philippe DESPLATS (philippe@dirupt.com)
*/

export * from './SMenuUserIcon'
